module.exports = __webpack_public_path__ + "src/assets/img/light_turn_l.a719ea29.svg";